<template>
    <div class="container translated-text">
        <div class="row description d-flex align-items-center">
            <div
                style="max-width: 80%; padding: 0px"
                class="col sc-message--text-content translated-text-content d-flex align-items-center"
                v-html="data.text"
            />
            <div
                style="max-width: 5%; padding: 0px; justify-content: end"
                class="col sc-message--text-content translated-text-content d-flex align-items-center"
            >
                <p
                    v-tippy="{
                        followCursor: true,
                        placement: 'top-center',
                        theme: isDarkMode ? 'light-border' : 'google',
                    }"
                    :content="
                        $t('message.translatedTextDescription', { from: getLabel(data.from), to: getLabel(data.to) })
                    "
                    class="m-0"
                    style="color: #1890ff; font-size: 10px"
                >
                    <a-icon type="info-circle" />
                </p>
            </div>
            <!--            <img id="aws-logo" alt="aws logo" class="mr-1" src="/static/img/aws.png" />-->
        </div>
    </div>
</template>

<script>
import languages from "../../language/languages.json";
import { mapGetters } from "vuex";

export default {
    name: "TranslatedText",
    props: ["data"],
    data() {
        return {
            languages,
        };
    },
    methods: {
        getLabel(code) {
            let maybeLang = this.languages.find((x) => x.code === code);
            return !!maybeLang ? maybeLang.originalName : code;
        },
    },
    computed: {
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
        }),
    },
};
</script>

<style scoped>
.translated-text-content {
    color: black !important;
    opacity: 0.7;
    font-size: 14px;
}
</style>
